import DataTable from "../components/DataTable";
import { hostname } from "../hooks/useEndeavour";
import { Form, Input, InputNumber, Button, Space, Select } from "antd";
import { AppstoreAddOutlined, EditOutlined } from "@ant-design/icons";
import AddCampaignRuleModal from "../components/AddCampaignRuleModal";
import UpdateCampaignRuleModal from "../components/UpdateCampaignRuleModal";
import { useRef, useState } from "react";

export default function CampaignRulesPage() {
  const [forceUpdate, setForceUpdate] = useState(0);
  const addRuleRef = useRef();
  const updateRuleRef = useRef();

  const onAddRule = () => {
    addRuleRef.current.openModal();
  };

  const onUpdateRule = (data) => {
    updateRuleRef.current.openModal(data);
  };

  const onUpdate = () => {
    setForceUpdate(forceUpdate + 1);
  };

  return (
    <>
      <AddCampaignRuleModal ref={addRuleRef} onChange={onUpdate} />
      <UpdateCampaignRuleModal ref={updateRuleRef} onChange={onUpdate} />
      <DataTable
        uri={`${hostname}/pa-alliance/campaign/rule`}
        ForceUpdate={forceUpdate}
        tableTitle={
          <Button type="primary" icon={<AppstoreAddOutlined />} onClick={onAddRule}>
            Create Campaign Rule
          </Button>
        }
        name="Campaign Rules"
        filters={[
          <Form.Item label="Name" name="name">
            <Input />
          </Form.Item>,
          <Form.Item label="Type" name="type">
            <Input />
          </Form.Item>,
          <Form.Item label="Condition Value" name="condition_value">
            <Input />
          </Form.Item>,
          <Form.Item label="Entry" name="entry">
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>,
          <Form.Item label="Operator" name="operator">
            <Select
              allowClear
              options={[
                { value: "gt", label: ">" },
                { value: "gte", label: ">=" },
                { value: "eq", label: "==" },
                { value: "lte", label: "<=" },
                { value: "lt", label: "<" },
              ]}
            />
          </Form.Item>,
        ]}
        tableColumns={[
          {
            title: "Name",
            dataIndex: "name",
            key: "name",
          },
          {
            title: "Type",
            dataIndex: "type",
            key: "type",
          },
          {
            title: "Operator",
            dataIndex: "operator",
            key: "operator",
            render: (val) => ({ gt: "Greater Than", gte: "Greater Than or Equal", eq: "Equal", lte: "Less Than or Equal", lt: "Less Than" }[val] || val),
          },
          {
            title: "Condition Value",
            dataIndex: "condition_value",
            key: "condition_value",
          },
          {
            title: "Entry",
            dataIndex: "entry",
            key: "entry",
          },
          {
            title: "Action",
            render: (data) => {
              return (
                <Space>
                  <Button icon={<EditOutlined />} onClick={() => onUpdateRule(data)} type="primary">
                    Edit
                  </Button>
                </Space>
              );
            },
          },
        ]}
      />
    </>
  );
}
